import { CHANGE_REGION } from '../actions';

let initialState = '';

function region(state = initialState, action) {

    let region = action.region;

    if(region === undefined) {
    	region = state;
	}


	switch (action.type) {
		case CHANGE_REGION:
			return region;
		default:
			return state;
	}
}
export default region;


// WEBPACK FOOTER //
// ./src/reducers/region.js